import $ from 'jquery';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';

export const handleCapture = (deviceName, dmtType, onSuccess) => {
    console.log('Capture started');
    console.log('deviceName', deviceName, 'dmtType', dmtType);
    if (!deviceName) {
        globalNotifyError('Device name is required');
        return;
    }

    // Define XML based on dmtType
    let xml = '';

    if (dmtType === 'fino') {
        xml = `<?xml version="1.0"?>
            <PidOptions ver="1.0">
                <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" posh="UNKNOWN" env="P" wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=" />
                <CustOpts>
                    <Param name="mantrakey" value="Type1Key" />
                </CustOpts>
            </PidOptions>`;
    } else if (dmtType === 'iserveu') {
        console.log('iserveu');
        xml = `<?xml version="1.0"?>
    <PidOptions ver="1.0">
      <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="UNKNOWN" env="P" />
      <CustOpts>
        <Param name="mantrakey" value="" />
      </CustOpts>
    </PidOptions>`;
    } else if (dmtType === 'airtel') {
        console.log('airtel finger');
        xml = `<?xml version="1.0"?>
    <PidOptions ver="1.0">
      <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" indicatorforUID="0" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh="UNKNOWN" env="P" otp="" />
      <Demo></Demo>
      <CustOpts>
        <Param name="mantrakey" value="" />
      </CustOpts>
    </PidOptions>`;
    } else {
        globalNotifyError('Invalid dmtType');
        return;
    }
    const deviceUrls = {
        MFS110: 'https://127.0.0.1:11100/rd/capture',
        MSO1300E3: 'https://127.0.0.1:11100/capture',
        FM220UL1: 'https://localhost:11200/rd/capture',
        PB1000: 'http://127.0.0.1:11100/rd/capture',
        AST300: 'https://localhost:11200/rd/capture'
    };

    function getErrorInfo(xmlString) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
        const respElement = xmlDoc.querySelector('Resp');

        return respElement?.getAttribute('errInfo') || null;
    }

    const url = deviceUrls[deviceName.replace(/\s+/g, '')];
    if (!url) {
        globalNotifyError('Unsupported device');
        return;
    }

    if (deviceName.replace(/\s+/g, '') === 'FM220UL1' || deviceName.replace(/\s+/g, '') === 'AST300') {
        $.ajax({
            type: 'CAPTURE',
            async: false,
            crossDomain: true,
            url: 'https://localhost:11200/rd/capture',
            data: xml,
            contentType: 'text/xml; charset=utf-8',
            processData: false,
            success: function (data) {
                const xmlString = new XMLSerializer().serializeToString(data);
                $('div.spanner').addClass('show');
                $('#txtPidData').val(xmlString);
                const errorMessage = getErrorInfo(xmlString);
                console.log('errorMessage', errorMessage);

                if (!errorMessage) {
                    onSuccess && onSuccess(xmlString);
                } else {
                    onSuccess && onSuccess('');
                    globalNotifyError(errorMessage);
                }
            },
            error: function (jqXHR) {
                $('div.spanner').removeClass('show');
                globalNotifyError('Please Connect Your Biometric Device');
                console.log('Error:', jqXHR);
            }
        });
    } else {
        $.ajax({
            type: 'CAPTURE',
            async: false,
            crossDomain: true,
            url: url,
            data: xml,
            contentType: 'text/xml; charset=utf-8',
            processData: false,
            success: function (data) {
                $('div.spanner').addClass('show');
                $('#txtPidData').val(data);
                const xmlString = data;

                const error = getErrorInfo(xmlString);
                if (error === 'Success.') {
                    globalNotifySuccess('Finger Capture Success');
                    onSuccess && onSuccess(data);
                } else {
                    globalNotifyError(error);
                    onSuccess && onSuccess('');
                }
            },
            error: function (jqXHR) {
                $('div.spanner').removeClass('show');
                globalNotifyError('Please Connect Your Biometric Device');
                console.log('Error:', jqXHR);
            }
        });
    }
};
